import { computed } from 'vue'
import { useCore } from '@/composables/core'
import { ROUTE_META_PARAMS } from '@/router/consts.ts'

export default {
  [ROUTE_META_PARAMS.STATUS_GETTER]: () => {
    return computed(() => {
      const { store, t } = useCore()
      const { business } = (store.state as { business: { business: Record<string, unknown> } }).business

      const label = business.turntracker_enabled
        ? t('components.turn-tracker.advanced-options.activated')
        : t('components.turn-tracker.advanced-options.inactive')
      const color = business.turntracker_enabled ? 'green' : undefined
      const icon = business.turntracker_enabled ? 'circle-tick' : undefined

      return {
        label,
        color,
        icon,
      }
    })
  },
}
